module.exports = __webpack_public_path__ + "img/1-1.006d8b86.png";